export class SendingStatusItem {

  active: boolean;
  done: boolean;
  progress: boolean;
  percentage: number;

  constructor() {
    this.active = false;
    this.done = false;
    this.progress = true;
    this.percentage = 0;
  }

}



// WEBPACK FOOTER //
// ./src/models/sendingstatusitem.ts